import { VehicleSearchScreen } from "@src/features/vehicles/screens/VehicleSearchScreen";

export default function VehiclesScreen() {
  return <VehicleSearchScreen />;
}
